import RectangleBlock from "../block/RectangleBlock.jsx";
import { RigidBody } from "@react-three/rapier";
import RoundedBoxComponent from "../block/RoundedBoxComponent.jsx";
import { useGame } from "../../../stores/useGame.js";
import { COLORS } from "../../../constants/colors";

const RaceStart = ({ position = [0, 0, 0], rotation = [0, 0, 0] }) => {
  const startRace = useGame((state) => state.startRace);
  return (
    <group position={position} rotation={rotation}>
      <RigidBody type="fixed" friction={1} restitution={0} ccd={false}>
        <mesh>
          <boxGeometry args={[6, 0.01, 6]} />
          <meshStandardMaterial color={COLORS.surfaceElements} />
        </mesh>
      </RigidBody>
      <RectangleBlock position={[2.8, 0.6, 0]} />
      <RectangleBlock position={[-2.8, 0.6, 0]} />
      {!startRace && (
        <>
          <RoundedBoxComponent position={[1.5, 0.04, 2]} />
          <RoundedBoxComponent position={[0, 0.04, 2]} />
          <RoundedBoxComponent position={[-1.5, 0.04, 2]} />
        </>
      )}
    </group>
  );
};

export default RaceStart;
